/**
 * Field Options API
 *
 * CRUD for admin-managed dropdown option values (e.g., IRI Segment, Style).
 */

import { apiClient } from './client';
import type {
  FieldOptionCreateRequest,
  FieldOptionDeprecateRequest,
  FieldOptionField,
  FieldOptionFieldKey,
  FieldOptionRenameRequest,
  FieldOptionRenameResponse,
  FieldOptionValue,
} from './types';

export const getFieldOptionFields = async (): Promise<FieldOptionField[]> => {
  const response = await apiClient.get<FieldOptionField[]>('/field-options/fields');
  return response.data;
};

export const getFieldOptions = async (
  fieldKey: FieldOptionFieldKey,
  includeDeprecated: boolean
): Promise<FieldOptionValue[]> => {
  const response = await apiClient.get<FieldOptionValue[]>(`/field-options/${fieldKey}`, {
    params: { includeDeprecated },
  });
  return response.data;
};

export const createFieldOption = async (
  fieldKey: FieldOptionFieldKey,
  request: FieldOptionCreateRequest
): Promise<FieldOptionValue> => {
  const response = await apiClient.post<FieldOptionValue>(`/field-options/${fieldKey}`, request);
  return response.data;
};

export const renameFieldOption = async (
  fieldKey: FieldOptionFieldKey,
  optionId: number,
  request: FieldOptionRenameRequest
): Promise<FieldOptionRenameResponse> => {
  const response = await apiClient.patch<FieldOptionRenameResponse>(
    `/field-options/${fieldKey}/${optionId}/rename`,
    request
  );
  return response.data;
};

export const setFieldOptionDeprecated = async (
  fieldKey: FieldOptionFieldKey,
  optionId: number,
  request: FieldOptionDeprecateRequest
): Promise<FieldOptionValue> => {
  const response = await apiClient.patch<FieldOptionValue>(
    `/field-options/${fieldKey}/${optionId}/deprecate`,
    request
  );
  return response.data;
};
